import React, { useState, useEffect } from 'react'
import cx from 'classnames'

import {
  FormControl,
  Input,
  InputLabel,
  IconButton,
  InputAdornment,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'

import { makeStyles } from '@material-ui/core/styles'
import { Theme } from '../LoginForm'

const styles = makeStyles({
  red: {
    color: '#f8003d !important',
  },

  black: {
    color: 'rgb(20,20,20) !important',
  },

  focusedLabel: {
    fontSize: 12,
    color: '#ED154E !important',
  },
  label: {
    fontSize: 16,
  },
  inputField: {
    background: 'transparent',
    border: 'none',
    color: '#fff',
    fontSize: 17,
    borderBottom: 'solid 1px #ED154E !important',
    fontWeight: 'normal',
    padding: 8,
    '&:hover:not(:focus)': {
      border: 'none',
    },
  },
  inputFieldFocused: {
    '&:focus': {
      borderColor: 'transparent',
    },
  },
  clear: {
    color: '#7F7F7F',
    padding: 4,
    position: 'relative',
    left: 6,
    top: -5,
    '& svg': {
      height: 16,
      width: 16,
    },
  },
})

interface VerificationCodeFieldProps {
  onChange: Function
  emailOrPhone: string
  theme: Theme
}

const VerificationCodeField: React.FC<VerificationCodeFieldProps> = (props) => {
  const { onChange, emailOrPhone, theme } = props
  const classes = styles()
  const [code, setCode] = useState('')

  useEffect(() => {
    onChange(code)
  }, [code])

  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    setCode(event.currentTarget.value)
  }

  return (
    <FormControl>
      <InputLabel
        classes={{
          shrink: classes.focusedLabel,
        }}
        className={classes.label}
        htmlFor="code"
      >
        Enter verification code
      </InputLabel>
      <Input
        classes={{
          input: cx(classes.inputField, theme === Theme.Light && classes.black),
          focused: classes.inputFieldFocused,
        }}
        id="code"
        endAdornment={
          <InputAdornment position="end">
            {!!emailOrPhone.length && (
              <IconButton onClick={() => setCode('')} className={classes.clear}>
                <Close />
              </IconButton>
            )}
          </InputAdornment>
        }
        value={code}
        onChange={handleChange}
      />
    </FormControl>
  )
}

export default VerificationCodeField
